import type { DifferenceExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const subtractResolver =
  createSimpleNamedExpressionResolver<DifferenceExpression>(
    'subtract',
    (minuend, subtrahend) => minuend - subtrahend
  );
